/**
 * Đảm bảo thời gian loading UI tối thiểu — tránh flash skeleton quá nhanh.
 */

/** Thời gian tối thiểu mặc định (ms) cho trạng thái loading. */
export const UI_MIN_DELAY_MS = 700;

/**
 * Chờ đủ minMs kể từ startedAt trước khi resolve.
 * @param {number} startedAt - Date.now() lúc bắt đầu request
 * @param {number} [minMs=UI_MIN_DELAY_MS]
 * @returns {Promise<void>}
 */
export const waitMinimumDelay = (startedAt, minMs = UI_MIN_DELAY_MS) =>
  new Promise((resolve) => {
    const remaining = Math.max(0, minMs - (Date.now() - startedAt));
    window.setTimeout(resolve, remaining);
  });
